module.exports = {
  model: { id: '', name: '', value: '' },
}
